// src/hooks/useSensorMonitoring.js
import { useState, useEffect } from 'react';
import { fetchLatestSensorData } from '../services/sensorService';

const useSensorMonitoring = (intervalMs = 5000) => {
  const [sensorData, setSensorData] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    setLoading(true);
    try {
      const data = await fetchLatestSensorData();
      setSensorData(data);
    } catch (err) {
      console.error('모니터링 데이터 로드 실패:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
    const interval = setInterval(loadData, intervalMs);
    return () => clearInterval(interval);
  }, [intervalMs]);

  return { sensorData, loading, reload: loadData };
};

export default useSensorMonitoring;
